let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("he2Tv")]).then(() => parcelRequire('ior5s'));